// extracted by mini-css-extract-plugin
export default {"header":"qJ","container":"rJ","accordeonitem":"sJ","itemsticky":"tJ","itemopen":"uJ","open":"vJ","productname":"wJ","productinfo":"xJ","flavorstext":"yJ","invalidlimit":"zJ","limit":"AJ","scrollUpAccordion":"BJ","wrapper":"CJ"};
    if(module.hot) {
      // 1730991508729
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  